import { YesNoField } from "components/fields/YesNoField";
import { WarningField } from "components/HighlightList";
import { FieldType } from "entities/FieldType";
import React from "react";
import { TextField, useRecordContext } from "react-admin";

export const CustomFieldWarningColumn = ({ customField }) => {
	const record = useRecordContext();
	const field = record?.custom_fields?.find((cf) => cf.key === customField.key);
	if (!field) return null;

	const { value, type } = field;

	switch (type) {
		case FieldType.bool:
			return (
				<WarningField
					component={YesNoField}
					record={{ [field.key]: value, details_info: record.details_info }}
					source={field.key}
					label={field.name}
				/>
			);
		case FieldType.datetime:
			return (
				<WarningField
					component={TextField}
					record={{ [field.key]: value, details_info: record.details_info }}
					source={field.key}
					label={field.name}
				/>
			);
		case FieldType.integer:
			return (
				<WarningField
					component={TextField}
					record={{ [field.key]: value, details_info: record.details_info }}
					source={field.key}
					label={field.name}
				/>
			);
		case FieldType.float:
			return (
				<WarningField
					component={TextField}
					record={{ [field.key]: value, details_info: record.details_info }}
					source={field.key}
					label={field.name}
				/>
			);
		default:
			return (
				<WarningField
					component={TextField}
					record={{ [field.key]: value, details_info: record.details_info }}
					source={field.key}
					label={field.name}
				/>
			);
	}
};
